import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { track } from "../../lib/tracking";

const includes = [
  "10 Underarm Laser Hair Reduction Sessions",
  "Doctor-supervised treatment",
  "Personalised treatment settings",
  "Advanced laser technology",
  "Annual maintenance session — 1 complimentary session every year for up to 10 years",
];

export const PackageSection = ({ onBook }) => (
  <section id="package" data-testid="package-section" className="py-24 md:py-36 bg-sand/50 border-y border-champagne/40">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead
        index="02"
        eyebrow="The Offer"
        title="Your ₹22,500 Package Includes"
        align="center"
      />
      <Reveal delay={0.15} className="mt-16 max-w-3xl mx-auto">
        <div
          data-testid="package-card"
          className="relative rounded-[2.5rem] border border-champagne bg-white p-8 md:p-14 shadow-[0_50px_100px_-50px_rgba(26,59,57,0.35)] overflow-hidden"
        >
          <div className="pointer-events-none absolute -top-24 -right-24 w-72 h-72 rounded-full bg-champagne-light/60 blur-3xl" aria-hidden="true" />
          <p className="text-center font-mono text-[0.65rem] uppercase tracking-[0.35em] text-teal/60">
            Underarm Laser Hair Reduction · Signature Package
          </p>
          <div className="mt-8 flex flex-col items-center">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/40">Regular value</p>
            <p data-testid="package-regular-price" className="price-strike mt-1 font-display text-2xl md:text-3xl font-light text-wine/80">
              ₹35,000
            </p>
            <p data-testid="package-special-price" className="mt-4 font-display text-7xl md:text-8xl font-light tracking-tight text-teal leading-none">
              ₹22,500
            </p>
            <p className="mt-3 font-mono text-[0.65rem] uppercase tracking-[0.3em] text-teal/60">Special package price</p>
            <span
              data-testid="package-savings-badge"
              className="mt-6 inline-flex items-center rounded-full bg-teal px-6 py-2 font-mono text-xs tracking-[0.25em] text-champagne-light"
            >
              You save ₹12,500
            </span>
          </div>
          <ul className="mt-12 space-y-4 max-w-xl mx-auto">
            {includes.map((item, i) => (
              <li key={item} data-testid={`package-include-${i + 1}`} className="flex items-start gap-4">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-teal/10">
                  <Check className="w-3.5 h-3.5 text-teal" strokeWidth={2.5} />
                </span>
                <span className="text-sm md:text-base font-light leading-relaxed text-ink/75">{item}</span>
              </li>
            ))}
          </ul>
          <button
            onClick={() => { track("book_package_click", { placement: "package" }); onBook(); }}
            data-testid="package-claim-button"
            className="group mt-12 flex w-full items-center justify-center gap-3 rounded-full bg-teal px-8 py-5 text-sm font-bold uppercase tracking-[0.18em] text-ivory transition-colors duration-300 hover:bg-teal-800"
          >
            Claim the ₹22,500 Package
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
          </button>
          <p className="mt-6 text-center text-xs font-light leading-relaxed text-ink/45">
            Results vary depending on hair type, skin type, hormones and individual response. Terms and eligibility apply.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
